import React, { useContext, useState } from "react";
import { SplideSlide } from "@splidejs/react-splide";
import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";

import { Icon } from "ui";
import { CurrencyContext } from "modules/currency/CurrencyContext";
import CurrencyPrice from "modules/currency/CurrencyPrice";
import Splider from "../../component-v2/Splider";
import { formatPrice } from "../../modules/search-building/utils";
import { SEARCH_PROJECTS_QUERY } from "../queries";

// Default theme
import "@splidejs/react-splide/css";
import { cn } from "@coninsa-s2/utils";

function removeTags(str) {
  if (str === null || str === "") return false;
  str = str.toString();

  return str.replace(/(<([^>]+)>)/gi, "");
}

function NewProjectsSlider({ withFilters, perPage }) {
  const currencySettings = useContext(CurrencyContext);
  const [currentKey, setCurrentKey] = useState();
  const { loading, error, data, refetch } = useQuery(SEARCH_PROJECTS_QUERY, {
    variables: {
      searchText: "",
    },
  });

  const slideSettings = {
    perPage,
    padding: { left: 0, right: "4rem" },
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (error) {
    return <div>Error...</div>;
  }

  const projects = data?.searchAPISearch?.documents;

  const regions = [
    { key: "Antioquia", label: "Antioquia" },
    { key: "Cundinamarca", label: "Cundinamarca" },
    { key: "Atlántico", label: "Atlántico" },
    { key: "Magdalena", label: "Magdalena" },
  ];

  return (
    <div>
      {withFilters && (
        <div className="flex items-center mb-4 justify-between">
          <div className="flex items-center flex-wrap gap-2">
            <div className="basis-full md:basis-auto font-medium">
              Por ubicación:
            </div>

            {regions.map((region) => (
              <div>
                <a
                  className={cn(
                    "inline-flex cursor-pointer rounded-2xl border border-solid border-coninsa-green-500 px-6 py-1 text-coninsa-green-500 font-semibold hover:bg-coninsa-green-500 hover:text-coninsa-white-300",
                    currentKey === region?.key &&
                      "bg-coninsa-green-500 text-coninsa-white-300"
                  )}
                  onClick={() => {
                    refetch({ searchText: `${region?.key}` });
                    setCurrentKey(region.key);
                  }}
                >
                  {region?.label}
                </a>
              </div>
            ))}
          </div>

          <a
            href="/proyectos"
            target="_blank"
            className="hidden md:block border border-coninsa-green-300 bg-coninsa-green-300 font-bold text-sm text-white rounded-lg py-3 px-5 uppercase
            hover:border-coninsa-green-500 hover:bg-coninsa-green-500"
          >
            Todos los proyectos
          </a>
        </div>
      )}

      <Splider options={slideSettings} aria-label="Proyectos nuevos">
        {projects.map((project) => {
          const imageUrl = project?.images?.[0];
          const summaryDesc = removeTags(project.description);
          const location = project?.location?.toLowerCase();
          const price = (project?.price || 0) / currencySettings.divider;

          return (
            <SplideSlide>
              <div className="mb-4 shadow-md rounded-lg overflow-hidden relative">
                <img src={imageUrl} className="h-52 object-cover" />

                <div className="p-4">
                  <h5 class="text-coninsa-blue-900 font-display text-2xl mb-2">
                    <a
                      href={project.url}
                      className="after:absolute after:inset-0 line-clamp-1"
                      target="_blank"
                    >
                      {project.name}
                    </a>
                  </h5>

                  <p className="line-clamp-4 text-sm mb-4">{summaryDesc}</p>

                  <div className="flex gap-2 text-coninsa-blue-300">
                    <Icon className="flex-shrink-0" name="gr-location" />
                    <div className="capitalize text-sm font-medium h-9">
                      {location}
                    </div>
                  </div>

                  <p className="font-semibold">
                    Desde
                    <span className="font-medium font-display ml-2 text-2xl">
                      {formatPrice(price, currencySettings.symbol)}
                    </span>
                  </p>
                </div>
              </div>
            </SplideSlide>
          );
        })}
      </Splider>

      <div className="mb-4">
        <CurrencyPrice />
      </div>

      <a
        href="/proyectos"
        target="_blank"
        className="block w-full min-w-[7.125rem] md:hidden border border-coninsa-green-300
          bg-coninsa-green-300 font-bold text-sm text-white rounded-lg py-3 px-5 uppercase"
      >
        Todos los proyectos
      </a>
    </div>
  );
}

NewProjectsSlider.defaultProps = {
  withFilters: true,
  perPage: 4,
};

NewProjectsSlider.propTypes = {
  withFilters: PropTypes.bool,
  perPage: PropTypes.number,
};

export default NewProjectsSlider;
